/** As mensagens do José, o Desk Tutor, com a formatação que a IA escreve (tutorText.ts). */
import { Fragment } from 'react';
import { parseTutorText, type TutorInline } from './tutorText.js';

export function TutorText({ text }: { text: string }) {
  return (
    <div className="rd-tutorText">
      {parseTutorText(text).map((block, index) => {
        if (block.kind === 'paragraph') {
          return (
            <p key={index}>
              <Inlines items={block.inlines} />
            </p>
          );
        }
        const List = block.ordered ? 'ol' : 'ul';
        return (
          <List key={index}>
            {block.items.map((item, i) => (
              <li key={i}>
                <Inlines items={item} />
              </li>
            ))}
          </List>
        );
      })}
    </div>
  );
}

function Inlines({ items }: { items: TutorInline[] }) {
  return (
    <>
      {items.map((item, index) => {
        if (item.kind === 'text') return <Fragment key={index}>{item.text}</Fragment>;
        if (item.kind === 'code') return <code key={index}>{item.text}</code>;
        if (item.kind === 'strong') {
          return (
            <strong key={index}>
              <Inlines items={item.children} />
            </strong>
          );
        }
        return (
          <a key={index} href={item.href} target="_blank" rel="noopener noreferrer">
            <Inlines items={item.children} />
          </a>
        );
      })}
    </>
  );
}
